import { Component, Input } from '@angular/core';

@Component({
    selector: 'informative-pebble-icon',
    templateUrl: './informative-pebble-icon.component.html',
    styleUrls: ['./informative-pebble-icon.component.scss']
})
export class InformativePebbleIconComponent {
    @Input() icon: string | null = null;
    @Input() imageUrl: string | null = null;
    @Input() pebbleBackgroundColor = '';
    @Input() pebbleIconColor = '';
    @Input() hideImageOnSmallScreen = false;
}
